import { useBreakpointValue } from "@chakra-ui/react";
import { HeaderDesktop } from "./HeaderDesktop";
import { HeaderMobile } from "./HeaderMobile";

export function Header() {
  const isWideVersion = useBreakpointValue({ base: false, lg: true });

  return <>{isWideVersion ? <HeaderDesktop /> : <HeaderMobile />}</>;
}
